import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
//import "./view.scss";

function View() {
    return (
        <>
            <Header />
            <div>aa</div>
            <Footer />
        </>
    );
}

export default View;
